import { ChangeEvent, FocusEvent, FormEvent, useState } from 'react';
import { Button, ButtonVariants } from '../../../Atoms/Button';
import { VALIDATION_ENUMS } from './Common/validator';
import { TextInput } from './TextInput';
import { FORM_DATA } from './Utils/types';

interface WebinarFormProps {
  onTextChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlurField: (e: FocusEvent<HTMLInputElement>) => void;
  onSubmitForm: (e: FormEvent) => void;
  formData: Record<string, FORM_DATA>;
  buttonText: string;
  onClick?: () => void;
  isFormSubmitting: boolean;
}

export const WebinarForm = ({
  onTextChange,
  onBlurField,
  onSubmitForm,
  formData,
  buttonText,
  onClick,
  isFormSubmitting,
}: WebinarFormProps): JSX.Element => {
  const [checkbox, setCheckBox] = useState(true);

  return (
    <form
      data-testid="webinar-lead-form"
      onSubmit={onSubmitForm}
      className="contact-sales-form flex flex-wrap"
    >
      {Object.keys(formData).map((key) => {
        const field = formData[key];
        return field ? (
          <div className={`${field.classes || 'w-full'}`} key={field.id}>
            <TextInput
              id={field.id}
              label={field.label}
              showLabel={field.showLabel}
              placeholder={field.placeholder}
              onTextChangeFn={onTextChange}
              onBlurFn={onBlurField}
              errors={field.errors}
              value={field.value}
              required={field.validation.includes(VALIDATION_ENUMS.IS_REQUIRED)}
            />
          </div>
        ) : null;
      })}

      <div className="flex gap-4 pb-4">
        <input
          data-testid="whatsapp-consent"
          type="checkbox"
          checked={checkbox}
          onChange={() => setCheckBox(!checkbox)}
        />
        <span className="text-font-200 text-s-12 sm:text-s-10">
          By submitting the form, you agree to get whatsapp reminders
        </span>
      </div>

      <div
        className="w-full flex justify-center"
        data-testid="webinar-lead-form-button"
      >
        <Button
          variant={ButtonVariants.bluefilled}
          className={`rounded-sm text-base w-full ${
            isFormSubmitting ? 'opacity-50 cursor-not-allowed' : 'opacity-1'
          }`}
          type="submit"
          onClick={onClick}
        >
          {isFormSubmitting ? 'Submitting...' : buttonText}
        </Button>
      </div>
    </form>
  );
};
